module.exports = __webpack_public_path__ + "img/professional.122145fe.png";